import { FundingTypes } from "types";
import { floatWithComma2Normalizer } from "validators";

const getApproveNoteText = data => {
	const monthlyVolumeValue =
		data?.monthlyVolume !== null
			? floatWithComma2Normalizer(data?.monthlyVolume, "$")
			: "";
	const monthlyVolumeAmexValue =
		data?.monthlyVolumeAmex !== null
			? floatWithComma2Normalizer(data?.monthlyVolumeAmex, "$")
			: "";
	const visaMcDiscoverAVT =
		data?.visaMcDiscover_AVT !== null
			? floatWithComma2Normalizer(data?.visaMcDiscover_AVT, "$")
			: "";
	const amexAVT =
		data?.amex_AVT !== null
			? floatWithComma2Normalizer(data?.amex_AVT, "$")
			: "";
	const visaMcDiscoverHT =
		data?.visaMcDiscover_HT !== null
			? floatWithComma2Normalizer(data?.visaMcDiscover_HT, "$")
			: "";
	const amexHT =
		data?.visaMcDiscover_HT !== null
			? floatWithComma2Normalizer(data?.amex_HT, "$")
			: "";
	const fundingTypeText = FundingTypes.getDisplayName(data?.fundingType);
	const dailyDiscountText = data?.isDailyDiscount ? "Yes" : "No";
	const mccText = data?.mccCode || "";
	const mccDescriptionText = data?.merchantDescription || "";

	const reserveAmountText =
		data?.reserveAmount !== null
			? `Reserve amount (if applicable): $${data?.reserveAmount}`
			: "";
	const reserveText =
		data?.reserve !== null
			? `Reserve % (if applicable): ${data?.reserve}%\n`
			: "";

	return `Monthly Volume M/V/D: ${monthlyVolumeValue}
Monthly Volume Amex: ${monthlyVolumeAmexValue}
Avg. Ticket M/V/D: ${visaMcDiscoverAVT}
Avg. Ticket Amex: ${amexAVT}
High Ticket M/V/D: ${visaMcDiscoverHT}
High Ticket Amex: ${amexHT}
Funding Schedule: ${fundingTypeText}
Daily discount: ${dailyDiscountText}
MCC: ${mccText} - ${mccDescriptionText}
${reserveText}${reserveAmountText}`;
};

export default getApproveNoteText;
